// extracted by mini-css-extract-plugin
export default {"fr-view":"Filters_fr-view__qh5i5","text":"Filters_text__DJZbJ","range":"Filters_range__h8s1J","to":"Filters_to__LEF+0"};